@if (error) {
  <pr-color-panel [display]="'danger'">
    <pr-panel-body clazz="pam">
      <pr-label [name]="'error'" [width]="18" [height]="18">{{
        error?.message
      }}</pr-label>
    </pr-panel-body>
  </pr-color-panel>
}

<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <div class="checkbox-info">
                <pr-input-radio
                  direction="column"
                  [isDefault]="false"
                  columns="2"
                  formControlName="userUsCitizen"
                  label="Êtes-vous citoyen américain ?"
                  [toggle]="true"
                >
                </pr-input-radio>
              </div>
              <div class="checkbox-info">
                <pr-input-radio
                  direction="column"
                  [isDefault]="false"
                  columns="3"
                  formControlName="userUsResident"
                  label="Êtes-vous résident fiscal américain ?"
                  [toggle]="true"
                >
                </pr-input-radio>
              </div>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
  <div class="pr-form-submit action action-default flex-row"></div>
</form>
